import { LogisticRouteName } from '@invivodf/common/src/contexts/logistic-offer/routes/logistic-route-name'
import { DiscountRouteName } from '@invivodf/common/src/contexts/discount'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { INavigationLinks, INavigationSubMenu } from '../../domain/INavigationLinks'

export function useNavigationLinks(
  isPartnerWithNewOfferConfiguration: boolean,
  isCompaniesFeatureEnabled: boolean,
  isRedirectionsFeatureEnabled: boolean = false,
  isOrdersToValidateFeatureEnabled: boolean = false,
  isLogisticShippingPeriodsFeatureEnabled: boolean = false,
  isProductRequestsLinkVisible: boolean = false,
) {
  const i18n = useI18nForVue2()
  const navigationLinks: (INavigationLinks | INavigationSubMenu)[] = []

  if (isProductRequestsLinkVisible) {
    navigationLinks.push({
      icon: 'book-outlined',
      label: i18n.t('ctx.catalog.menu-label').toString(),
      parentLink: { name: 'search-cooperative' },
      subMenu: [
        { label: i18n.t('ctx.catalog.submenu.product-requests').toString(), link: { name: 'product-requests' } },
      ],
    })
  } else {
    navigationLinks.push({
      icon: 'book-outlined',
      label: 'Catalogue',
      link: { name: 'search-cooperative' },
    })
  }

  if (!isPartnerWithNewOfferConfiguration) {
    navigationLinks.push({
      icon: 'barcode',
      label: 'Offres',
      link: { name: 'offers' },
    })
  }

  navigationLinks.push({
    icon: 'promotion-outlined',
    label: 'Remises',
    link: { name: DiscountRouteName.LISTING },
  })

  if (isCompaniesFeatureEnabled) {
    navigationLinks.push({
      icon: 'store-outlined',
      label: i18n.t('ctx.companies.menu-label').toString(),
      subMenu: [
        {
          label: i18n.t('ctx.companies.submenu.prospects').toString(),
          link: { name: 'companies-prospects' },
        },
      ],
    })
  }

  if (isLogisticShippingPeriodsFeatureEnabled) {
    navigationLinks.push({
      icon: 'truck-outlined',
      label: i18n.t('ctx.logistic.menu-label').toString(),
      subMenu: [
        { label: i18n.t('ctx.logistic.submenu.offers').toString(), link: { name: LogisticRouteName.LIST } },
        {
          label: i18n.t('ctx.logistic.submenu.shipping-periods').toString(),
          link: { name: 'logistic-shipping-periods' },
        },
      ],
    })
  } else {
    navigationLinks.push({
      icon: 'truck-outlined',
      label: 'Offres logistiques',
      link: { name: LogisticRouteName.LIST },
    })
  }
  navigationLinks.push({
    icon: 'trending-up',
    label: 'Quotas',
    link: { name: 'quotas' },
  })
  if (isOrdersToValidateFeatureEnabled) {
    navigationLinks.push({
      icon: 'cart-bag-outlined',
      label: i18n.t('ctx.orders.menu-label').toString(),
      subMenu: [
        { label: i18n.t('ctx.orders.submenu.to-validate').toString(), link: { name: 'orders-to-validate' } },
        { label: i18n.t('ctx.orders.submenu.tracking').toString(), link: { name: 'orders' } },
      ],
    })
  } else {
    navigationLinks.push({
      icon: 'cart-bag-outlined',
      label: i18n.t('ctx.orders.menu-label').toString(),
      link: { name: 'orders' },
    })
  }

  navigationLinks.push({
    icon: 'plus',
    label: 'Développeurs',
    subMenu: [
      {
        label: 'Webhooks',
        link: { name: 'webhooks' },
      },
    ],
  })

  if (isRedirectionsFeatureEnabled) {
    navigationLinks.push({
      icon: 'switch',
      label: 'Redirections',
      link: { name: 'brand-redirections' },
    })
  }

  navigationLinks.push({
    icon: 'gear-outlined',
    label: 'Paramètres',
    link: { name: 'parameters' },
  })

  return { navigationLinks }
}
